export default new class Menu {
  constructor() {
    this.MOUSE_LOCS_TRACKED = 3;
    this.mouseLocs = [];
    this.activateClass = 'active';
    this.rowSelectorClass = 'catalog__menu-list_item';
    this.rowSelectors = document.querySelectorAll(`.${this.rowSelectorClass}`);
    this.elemHover = document.querySelector(`.catalog__menu-list_hover`);
    this.menu = document.querySelector(`.catalog__menu-list`);
    this.handler();
  }

  handler() {
    
    window.onload = function() {
      document.addEventListener('mousemove', mousemoveDocument);
    }

    let mouseLocs = [];
    let mousemoveDocument = (e) => {
        mouseLocs.push({x: e.pageX, y: e.pageY});

        if (mouseLocs.length > this.MOUSE_LOCS_TRACKED) {
            mouseLocs.shift();
        }
    };

    // true for blocked
    let activationDelay = () => {

        const tolerance = 75;
        
        let lastDelayLoc = null,
            offset = this.menu.getBoundingClientRect(),
            upperLeft = {
              x: offset.left,
              y: offset.top - tolerance
            },
            upperRight = {
              x: offset.left + this.menu.offsetWidth,
              y: upperLeft.y
            },
            lowerLeft = {
                x: offset.left,
                y: offset.top + this.menu.offsetHeight + tolerance
            },
            lowerRight = {
                x: offset.left + this.menu.offsetWidth,
                y: lowerLeft.y
            },
            loc = mouseLocs[mouseLocs.length - 1],
            prevLoc = mouseLocs[0];

            let decreasingCorner = upperRight,
                increasingCorner = lowerRight; 

            let decreasingSlope = this.slope(loc, decreasingCorner),
                increasingSlope = this.slope(loc, increasingCorner),
                prevDecreasingSlope = this.slope(prevLoc, decreasingCorner),
                prevIncreasingSlope = this.slope(prevLoc, increasingCorner); 
                
          if (decreasingSlope < prevDecreasingSlope && increasingSlope > prevIncreasingSlope) {
              lastDelayLoc = loc;
              return true;
          }    

        return false;
      }

      [...this.rowSelectors].forEach((rowSelector) => {
          rowSelector.addEventListener('click', (el) => {
              if(el.target.classList.contains(this.rowSelectorClass)) {
                this.activate(el);
              }
          });

          rowSelector.addEventListener('mouseenter', (el) => {

              if(activationDelay())
                return;

              this.activate(el);
          });
      });
  }

  activate(el) {
      [...this.rowSelectors].forEach((e) => {
          e.classList.remove(this.activateClass);
      });

      let menuNode = this.menu.getBoundingClientRect();
      let itemNode = el.target.getBoundingClientRect();

      this.elemHover.style.top = (parseInt(menuNode.y - itemNode.y - 30) * -1) + 'px';

      el.target.classList.add(this.activateClass);
  }

  slope(a, b) {
    return (b.y - a.y) / (b.x - a.x);
  };
}